/// <amd-module name="VSSUI/Components/PersonaCard/ContactCard" />
import * as React from "react";
import * as Resources from "VSSUI/VSS.Resources.VSSUI";
import { Label } from "OfficeFabric/Label";
import { ContactCardContactLineProps, ContactCardProps } from "./ContactCard.Props";

/** @deprecated */
export class ContactCardContactLine extends React.Component<ContactCardContactLineProps> {
    // Render
    public render(): JSX.Element {
        return (
            <div>
                <div className={this.props.padTop ? "contact-card-line-top" : "contact-card-line"}>
                    <div className="contact-card-span-label">{this.props.label}</div>
                    <div className="contact-card-span-content">
                        {this.props.link && this.props.content && (
                            <a className="profile-card-tab-element" href={this.props.link}>
                                {this.props.content}
                            </a>
                        )}
                        {!this.props.link && this.props.content}
                    </div>
                </div>
                <div style={{ clear: "both" }} />
            </div>
        );
    }
}

/** @deprecated */
export class ContactCard extends React.Component<ContactCardProps> {
    // Render
    public render(): JSX.Element {
        const { identity } = this.props;

        return (
            <div className="contact-or-organization-card-wrapper">
                {/* Section for heading */}
                <div className="contact-card-header-wrapper">
                    <div className="body-m">
                        <Label>{Resources.PeoplePickerContactInfo}</Label>
                    </div>
                </div>

                {/* Section for contact information */}
                <div className="contact-card-info-wrapper">
                    <ContactCardContactLine label={Resources.PeoplePickerEmail} content={identity.mail} link={`mailto:${identity.mail}`} />
                    <ContactCardContactLine
                        label={Resources.PeoplePickerPhoneNumber}
                        content={identity.telephoneNumber}
                        link={`mailto:${identity.telephoneNumber}`}
                    />
                    <ContactCardContactLine label={Resources.PeoplePickerLocation} content={identity.physicalDeliveryOfficeName} />

                    <ContactCardContactLine label={Resources.PeoplePickerTitle} content={identity.jobTitle} padTop={true} />
                    <ContactCardContactLine label={Resources.PeoplePickerDepartment} content={identity.department} />
                    <ContactCardContactLine label={Resources.PeoplePickerAlias} content={identity.mailNickname} />
                </div>
            </div>
        );
    }
}
